import {BlackoutDateProps, DAY} from "../../types/BlackoutPeriod";
import {hourToAMPM} from "../../utils/hourToAMPM";
import blackoutPeriodDay from "./BlackoutPeriodDay";
import {useContext} from "react";
import {BlackoutPeriodContext} from "./BlackoutPeriods";
import BlackoutPeriodItem from "./BlackoutPeriodItem";

interface BlackoutPeriodHourProps {
    day: DAY;
    hour: number;
    blackoutPeriods?: BlackoutDateProps[];
}

const BlackoutPeriodHour = ({ day, hour, blackoutPeriods }: BlackoutPeriodHourProps) => {
    const { hoveredId, periodColors } = useContext(BlackoutPeriodContext);
    return (
        <div className="hour">
            {blackoutPeriods?.length ? blackoutPeriods.map(blackoutPeriod => {
                const periodColor = blackoutPeriod?.id ? periodColors[blackoutPeriod?.id] : '#000';
                return <BlackoutPeriodItem key={`blackout-period-hour-${blackoutPeriod.id}-${day}-${hour}`} day={day} hour={hour} occupiedColor={periodColor} blackoutPeriod={blackoutPeriod} isHovered={blackoutPeriod?.id === hoveredId} />;
            }) : null}
        </div>
    )
}

export default BlackoutPeriodHour;